
import React, { useEffect, useState } from 'react';
import { MapPin } from 'lucide-react';
import { AnimatedSection } from '@/hooks/useScrollAnimation';

interface LocationSectionProps {
  onOpenBooking: () => void;
}

const LocationSection: React.FC<LocationSectionProps> = ({ onOpenBooking }) => {
  // Render iframe only after mount to avoid SSR/prerender hydration mismatch
  // (Puppeteer prerender saves the cross-origin iframe DOM, which doesn't match
  // React's virtual DOM on hydration → React error #418 → blank page).
  const [mounted, setMounted] = useState(false);
  useEffect(() => { setMounted(true); }, []);
  return (
    <section id="localizacao" aria-labelledby="location-title" className="bg-dark-base">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <AnimatedSection>
          <header className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
            <div>
              <p className="subtitle-wide text-gold mb-3 block">Onde nos encontrar</p>
              <h2 id="location-title" className="text-3xl md:text-4xl text-light-primary leading-tight tracking-tight">
                Cirurgicare — Curitiba
              </h2>
            </div>
            <address className="flex items-start gap-3 text-light-muted md:text-right not-italic">
              <MapPin className="h-5 w-5 text-gold mt-0.5 flex-shrink-0 md:order-2" aria-hidden="true" />
              <div className="text-sm md:order-1">
                <p className="text-light-secondary">R. Prof. Pedro Viriato Parigot de Souza, 600</p>
                <p className="mt-0.5">Loja 3001-B · Mossunguê · Curitiba — PR</p>
                <p className="text-light-muted/60 mt-0.5">CEP 81200-100</p>
              </div>
            </address>
          </header>
        </AnimatedSection>

        <AnimatedSection delay={100}>
          <figure className="rounded-2xl overflow-hidden border border-white/10 h-[400px] md:h-[500px] w-full m-0 relative bg-dark-elevated">
            {mounted && (
              <iframe
                title="Localização Dr. Luis Brunello — Cirurgião Plástico"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3602.7165520594053!2d-49.29879132379018!3d-25.447738233595302!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94dce3a59a69da77%3A0x1c7d7220457f2802!2sDr.%20Luis%20Brunello%20-%20Cirurgi%C3%A3o%20Pl%C3%A1stico!5e0!3m2!1spt-BR!2sbr!4v1776369433838!5m2!1spt-BR!2sbr"
                width="100%"
                height="100%"
                style={{ border: 0, display: 'block' }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            )}
            <a
              href="https://www.google.com/maps/search/?api=1&query=Cirurgicare+Curitiba"
              target="_blank"
              rel="noopener noreferrer"
              className="absolute bottom-4 right-4 btn-pill btn-gold font-semibold text-sm shadow-lg"
            >
              Abrir no Google Maps
            </a>
          </figure>
        </AnimatedSection>

        <AnimatedSection delay={200}>
          <footer className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-8 pt-8 border-t border-white/5">
            <p className="text-sm text-light-muted">
              Atendimento mediante agendamento prévio.
            </p>
            <button
              onClick={onOpenBooking}
              className="btn-pill btn-gold font-semibold text-sm"
            >
              Agendar pelo WhatsApp
            </button>
          </footer>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default LocationSection;
